export const environment = {
    production: true,
    apiEndPoint: 'https://dev-b-api.greatr.com.au/v1/admin',
};
